import {MileageType} from "../types/types";

export const swapProductShippingStatus = (status: string, request?: 'EXCHANGE' | 'RETURN', latestStatus?: string) => {
    switch (status) {
        case 'CANCELED':
            switch (request) {
                case 'EXCHANGE':
                    return '교환 신청 취소'
                case 'RETURN':
                    return '반품 신청 취소'
            }
            return '주문 취소'
        case 'CONFIRMED':
            return '구매 확정'
        case 'DELIVERED':
            switch (latestStatus) {
                case 'COMPLETED':
                    return '구매확정'
                // case 'CANCELED':
                //     return '취소 완료'
                default:
                    return '배송 완료'
            }
        case 'IN_DELIVERY':
            return '배송중'
        case 'IN_RETURN':
            switch (request) {
                case 'EXCHANGE':
                    switch (latestStatus) {
                        case 'CANCELED':
                            return '교환 신청 취소'
                        case "RETURNED":
                            return '수거 완료'
                        case "READY_DELIVERY":
                            return '배송 대기 중'
                        case 'DELIVERED':
                            return '배송 완료'
                        case 'REFUNDED':
                            return '환불 완료'
                        case 'IN_DELIVERY':
                            return '배송중'
                        case 'COMPLETED':
                            return '구매 확정'
                        default:
                            return '교환 신청'
                    }
                case 'RETURN':
                    switch (latestStatus) {
                        case 'CANCELED':
                            return '반품 신청 취소'
                        case "RETURNED":
                            return '수거 완료'
                        case "READY_DELIVERY":
                            return '배송 대기 중'
                        case 'DELIVERED':
                            return '배송 완료'
                        case 'REFUNDED':
                            return '환불 완료'
                        case 'IN_DELIVERY':
                            return '배송중'
                        case 'COMPLETED':
                            return '구매 확정'
                        default:
                            return '반품 신청'
                    }
                default:
                    return '-'
            }
        case 'NONE':
            return '-'
        case 'PENDING':
            switch (request) {
                case 'EXCHANGE':
                    return '교환 상품 준비 중'
                case 'RETURN':
                    return '반품 상품 준비 중'
                default:
                    return '상품 준비 중'
            }
        case 'RETURNED':
            switch (latestStatus) {
                case "RETURNED":
                    return '수거 완료'
                case "READY_DELIVERY":
                    return '배송 대기 중'
                case 'DELIVERED':
                    return '배송 완료'
                case 'REFUNDED':
                    return '환불 완료'
                case 'IN_DELIVERY':
                    return '배송중'
                case 'COMPLETED':
                    return '구매 확정'
                case 'PENDING':
                    switch (request) {
                        case 'EXCHANGE':
                            return '교환 신청'
                        case 'RETURN':
                            return '반품 신청'
                    }
                    return '반품 신청'
                default:
                    return '배송 완료'
            }
        case 'REFUNDED':
            return '반품 완료'
        default:
            return '-'
    }
}

export const swapOrderStatus = (status: string) => {
    switch (status) {
        case 'CANCELED':
            return '주문취소'
        case 'CONFIRMED':
            return '구매확정'
        case 'PAID':
            return '결제완료'
        case 'PENDING_CANCEL':
            return '환불신청'
        case 'READY':
            return '상품준비중'
        case 'WAIT':
            return '결제대기'
        default:
            return '-'
    }
}

export const swapPayMethod = (type: string) => {
    switch (type) {
        case 'CARD':
            return '신용카드'
        case 'VIRTUAL_ACCOUNT':
            return '에스크로 가상계좌'
        case 'TRANSFER':
            return '실시간 계좌이체'
        case 'CASH':
            return '현금결제'
        case 'KAKAO':
            return '카카오페이'
        case 'NAVER':
            return '네이버페이'
        default:
            return '-'
    }
}

export const swapCancelMethod = (type: string) => {
    switch (type) {
        case 'CARD':
            return '신용카드 취소'
        case 'VIRTUAL_ACCOUNT':
            return '계좌 입금'
        case 'TRANSFER':
            return '계좌 입금'
        case 'CASH':
            return '현금 환불'
        case 'KAKAO':
            return '카카오페이 취소'
        case 'NAVER':
            return '네이버페이 취소'
        default:
            return '-'
    }
}

export const swapGender = (gender: 'MALE' | 'FEMALE' | 'ETC') => {
    switch (gender) {
        case "MALE":
            return `남자`
        case "FEMALE":
            return '여자'
        case "ETC":
            return '선택 안 함'
        default:
            return '-'
    }
}

export const bankName = (code: string) => {
    switch (code) {
        case"KN":
            return '경남은행'
        case"KJ":
            return '광주은행'
        case"KM":
            return '국민은행'
        case"KU":
            return '기업은행'
        case"NH":
            return '농협'
        case"DG":
            return '대구은행'
        case"SL":
            return 'SJ산림'
        case"SU":
            return '산업은행'
        case"K":
            return '케이뱅크'
        case"SM":
            return '새마을금고'
        case"SUP":
            return '수협'
        case"CT":
            return '시티은행'
        case"SH":
            return '신한은행'
        case"SIN":
            return '신협'
        case"WR":
            return '우리은행'
        case"PO":
            return '우체국'
        case"JJ":
            return '제주은행'
        case"HS":
            return 'HSBC'
        case"SC":
            return 'SC제일은행'
        case"JB":
            return '전북은행'
        case"HN":
            return 'KEB하나은행'
        case"BS":
            return '부산은행'
    }
}

export const stringToDate = (dateString: string) => {
    return `${dateString.substring(0, 4)}.${dateString.substring(4, 6)}.${dateString.substring(6, 8)} ${dateString.substring(8, 10)}:${dateString.substring(10, 12)}:${dateString.substring(12, 14)}`
}

export const mileageTypeText = (type: MileageType) => {
    switch (type) {
        case "ADMIN_DEDUCT":
            return '운영자 차감'
        case "ADMIN_PROVIDE":
            return '운영자 지급'
        case "ORDER_EARN":
            return '주문 적립'
        case "ORDER_EARN_CANCEL":
            return '주문 적립 취소'
        case "ORDER_USE":
            return '주문시 사용'
        case "ORDER_USED_RETURN":
            return '주문 취소 환급'
        case "CONFIRM_CANCELED":
            return '구매확정 취소 차감'
    }
}
